var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container container-small" },
    [
      this.car
        ? _c("Heading", {
            staticClass: "py-4",
            attrs: { title: this.car._plateNo, routeName: "my-cars" },
          })
        : _vm._e(),
      !_vm.loading
        ? [
            _vm.car
              ? [
                  _c("div", { staticClass: "mt-0" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-5" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("label_license_plate"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.car._plateNo,
                                expression: "car._plateNo",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "has-error": _vm.errorMsgs._plateNo },
                            attrs: { type: "text" },
                            domProps: { value: _vm.car._plateNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.car,
                                  "_plateNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _vm._v(" " + _vm._s(_vm.errorMsgs._plateNo) + " "),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-12 col-md-7" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("label_chasis_number"))),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.car._chasisNo,
                                expression: "car._chasisNo",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "has-error": _vm.errorMsgs._chasisNo },
                            attrs: { type: "text" },
                            domProps: { value: _vm.car._chasisNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.car,
                                  "_chasisNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _vm._v(" " + _vm._s(_vm.errorMsgs._chasisNo) + " "),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm.countries
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "taraInmatriculare" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("label_registration_country"))
                            ),
                          ]),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.car._country,
                                  expression: "car._country",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "taraInmatriculare" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.car,
                                    "_country",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.countries, function (c) {
                              return _c(
                                "option",
                                { domProps: { value: c.id } },
                                [_vm._v(_vm._s(c.country))]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("label_choose_category")) + " "),
                        _c("b", [_vm._v(_vm._s(_vm.$tc("vignetteWord", 1)))]),
                        _vm._v(":"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "list-group mt-1" },
                        [
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _c("b", [_vm._v(_vm._s(_vm.errorMsgs._category))]),
                          ]),
                          _vm._l(_vm.categoriesVignette, function (item, key) {
                            return _c(
                              "div",
                              {
                                key: key,
                                staticClass:
                                  "list-group-item list-group-item-action",
                                class: [
                                  { active: _vm.car._category == item.id },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.setCategoryVignette(item.id)
                                  },
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.capitalize(_vm.$t("category"))) +
                                      " " +
                                      _vm._s(item.title)
                                  ),
                                ]),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item.desc) },
                                }),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("label_choose_category")) + " "),
                        _c("b", [_vm._v(_vm._s(_vm.$tc("tollWord", 1)))]),
                        _vm._v(":"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "list-group mt-1" },
                        [
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.errorMsgs._category_TPF)),
                            ]),
                          ]),
                          _vm._l(_vm.categoriesToll, function (item, key) {
                            return _c(
                              "div",
                              {
                                key: key,
                                staticClass:
                                  "list-group-item list-group-item-action",
                                class: [
                                  { active: _vm.car._category_TPF == item.id },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.setCategoryToll(item.id)
                                  },
                                },
                              },
                              [
                                _c("p", [_vm._v(_vm._s(item.title))]),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item.desc) },
                                }),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "text-center pt-3 pb-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-purple w-100",
                          on: {
                            click: function ($event) {
                              return _vm.updateCar()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btn_save_changes")))]
                      ),
                    ]),
                    _c("div", { staticClass: "pb-4 text-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-danger pointer",
                          on: {
                            click: function ($event) {
                              return _vm.remove()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-trash my-auto",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" " + _vm._s(_vm.$t("btn_delete_car"))),
                        ]
                      ),
                    ]),
                  ]),
                ]
              : [
                  _c("br"),
                  _c("div", [
                    _c("div", { staticClass: "text-center" }, [
                      _c("div", { staticClass: "alert alert-danger" }, [
                        _vm._v(_vm._s(_vm.$t("edit_car_no_vehicles"))),
                      ]),
                    ]),
                  ]),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }